import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable, signal} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';


@Injectable({providedIn: 'root'})
export class MatPaginatorIntlLocale extends MatPaginatorIntl {

    /** A label for the page size selector. */
    itemsPerPageLabel: string;
    /** A label for the button that increments the current page. */
    nextPageLabel: string;
    /** A label for the button that decrements the current page. */
    previousPageLabel: string;
    /** A label for the button that moves to the first page. */
    firstPageLabel: string;
    /** A label for the button that moves to the last page. */
    lastPageLabel: string;

    of = signal<string>('');
    elements = signal<string>('');
    element = signal<string>('');


    constructor(
        private translocoService: TranslocoService
    ) {
        super();

        this.translocoService.selectTranslate([
            'paginator.rowsPerPage',
            'paginator.nextPage',
            'paginator.previousPage',
            'paginator.firstPage',
            'paginator.lastPage',
            'paginator.totalElements',
            'paginator.element',
            'paginator.of'
        ]).subscribe((translations) => this.setTranslations(translations));
    }

    setTranslations(translations: string[]) {
        this.itemsPerPageLabel = translations[0];
        this.nextPageLabel = translations[1];
        this.previousPageLabel = translations[2];
        this.firstPageLabel = translations[3];
        this.lastPageLabel = translations[4];
        this.elements.set(translations[5]);
        this.element.set(translations[6]);
        this.of.set(translations[7]);
    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return '0 ' + this.of() + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        if (length === 1) {
            return startIndex + 1 + ' - ' + endIndex + ' ' + this.of() + ' ' + length + ' ' + this.element();
        } else {
            return startIndex + 1 + ' - ' + endIndex + ' ' + this.of() + ' ' + length + ' ' + this.elements();
        }
    };

}
